export { Typography } from './typography';
export { Paragraph } from './components/paragraph';
export { SmallParagraph } from './components/smallParagraph';
export { Text } from './components/text';
export { Label } from './components/label';
export { Title } from './components/title';
export { Subtitle } from './components/subtitle';
export { PrimaryFont } from './style/font';